module.exports = __webpack_public_path__ + "img/lafia_logo_main.e3692a9b.png";